module.exports = __webpack_public_path__ + "static/media/ethereum-logo.95c3ada2.svg";